import { Badge } from 'slab'
import { type EmployersRenewalsRateSummary as RateSummary } from 'utils/web_api.schemas'

type Props = {
  rateSummary: RateSummary
}

const formatRateChange = (rateChange: number) => {
  const isIncrease = rateChange > 0
  return `${isIncrease ? '+' : ''}${(rateChange * 100).toFixed(0)}%`
}

const rateSummaryBadge = (rateSummary: RateSummary) => {
  if (rateSummary.has_finalized_rates) {
    return <Badge type='success' bordered>Confirmed</Badge>
  }

  return <Badge bordered>Preliminary</Badge>
}

export default function RateSummaryItem ({ rateSummary }: Props) {
  const rateChangeText = () => {
    if (rateSummary.has_finalized_rates) {
      return formatRateChange(rateSummary.average_change)
    }

    return `${formatRateChange(rateSummary.min_change)} to ${formatRateChange(rateSummary.max_change)}`
  }

  return (
    <div className='flex gap-2 items-center'>
      <div className='body-sm-bold'>{rateSummary.state_abbreviation}</div>
      <div className='flex-1 border-b-4 border-dotted border-gray-200' />
      <div className='body-sm text-gray-500'>{rateChangeText()}</div>
      {rateSummaryBadge(rateSummary)}
    </div>
  )
}
